import { activityBatches } from './routesActivityBatches.access';
import { collections } from './routesCollections.access';
import { contents } from './routesContents.access';
import { editorialAccess } from './routesEditorialAccess.access';
import { fixedLayout } from './routesFixedLayout.access';
import { isFTD } from './routesFTD.access';
import { licenses } from './routesLicenses.access';
import { licensesBatch } from './routesLicensesBatch.access';
import { licensesBatchMono } from './routesLicensesBatchMono.access';
import { messages } from './routesLicensesMessages.access';
import { personalize } from './routesPersonalize.access';
import { programs } from './routesPrograms.access';
import { publications } from './routesPublications.access';
import { schools } from './routesSchools.access';
import { settingsApp } from './routesSettings.access';
import { tools } from './routesTools.access';
import { users } from './routesUsers.access';

export function canAccess({ flags, path, restrictedPrograms = false, settings, user }) {
  const accessChecks = [
    () => activityBatches({ flags, path, user }),
    () => collections(path, user),
    () => contents(path, user),
    () => editorialAccess(path, restrictedPrograms),
    () => fixedLayout(path, user, settings),
    () => isFTD(user, path),
    () => licenses(path, user),
    () => licensesBatch(path, user),
    () => licensesBatchMono({ flags, path, user }),
    () => messages({ flags, path }),
    () => personalize(path, user),
    () => programs(path, user),
    () => publications(path, user),
    () => schools(path, user),
    () => settingsApp(path, user, settings),
    () => tools(path, user),
    () => users(path, user),
  ];

  return accessChecks.every((check) => check());
}
